module.exports = __webpack_public_path__ + "static/report-09da5f2905801cb7265cb94c5eee7ee7.pdf";